import React, { Component } from 'react';
import { Radio } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";

/**
* Class RemoteRadioGroup
* Generic component to generate remote made radio
**/
class RemoteRadioGroup extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {data: []};
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading fields to display
  **/
  componentWillMount() {
    rest({method: 'GET', path: REST_API_URL + this.props.path + '/'}).then(response => {
      let state = this.state;
      state.data = JSON.parse(response.entity);
      this.setState(state);
    });
  }

  /**
  * render
  * Rendering component function : display the radio group
  **/
  render() {
    if(this.state.data === undefined || this.state.data.length === 0) return null;

    const radios = this.state.data.map((obj, index) => {
      let props = {
        key: obj[this.props.valueField],
        type: "radio",
        name: this.props.refField,
        value: obj[this.props.valueField],
        onChange: this.props.onChange,
        inline: true,
        //label: obj[this.props.labelField],
        defaultChecked: (this.props.value && obj[this.props.valueField] === this.props.value) || (!this.props.value && index === 0),
        disabled: this.props.disabled
      }

      //return <RemoteRadio {...props} />;
      return <Radio {...props}>{obj[this.props.labelField]}</Radio>;
    });

    return (
      <div className="remoteRadioGroup">{radios}</div>
    );
  }

}

export default RemoteRadioGroup;



// WEBPACK FOOTER //
// ./src/views/Helper/RemoteRadioGroup.js